import React from 'react'
import styled from 'styled-components'
import Clock from '../../components/Clock/Clock'
import {_L, useLocaleState} from '../../context/LocaleContext'

const MeetingRoomHeader = ({onCreateRequest}) => {
  const localeState = useLocaleState()

  return (
    <Container>
      <CenterContainer>
        <Clock size="large" />
      </CenterContainer>

      <ButtonContainer>
        <HeaderButton onClick={onCreateRequest}>
          {_L({key: 'Create Request', localeState})}
        </HeaderButton>
      </ButtonContainer>
    </Container>
  )
}

export default MeetingRoomHeader

const Container = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
`

const CenterContainer = styled.div`
  height: 100%;
  grid-area: center;
  padding-left: 32px;
  padding-top: 12px;
  color: white;
`

const ButtonContainer = styled.div`
  padding: 20px 20px 0 20px;
  box-sizing: border-box;
`

const HeaderButton = styled.div`
  font-size: 16px;
  font-weight: 400;
  height: 48px;
  width: 150px;
  border: none;
  border-radius: 6px;
  background-color: #1b1e2c;
  color: #5f6886;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  
  @media (max-width: 420px) {
    font-size: 12px;
  	height: 42px;
  	width: 120px;
  }
`
